import { motion } from 'framer-motion';
import styled from 'styled-components';

export const CommentsListCommentWrapper = styled(motion.div).attrs({
  exit: { height: 0, overflow: 'hidden' },
})``;

export const CommentsListTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

export const CommentsListTitleIconContainer = styled.div`
  width: 40px;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 100%;
  background: var(--color-primary);

  cursor: pointer;
`;

export const CommentsListTitle = styled.h2`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  color: var(--color-text);
`;
